export const FONT_SIZE_LEVELS = [
  { value: 0, label: 'XS' },
  { value: 1, label: 'S' },
  { value: 2, label: 'M' },
  { value: 3, label: 'L' },
  { value: 4, label: 'XL' },
  { value: 5, label: 'XXL' },
] as const;

export function getFontSizeLevelLabel(level: number): string {
  const i = Math.max(0, Math.min(5, Math.round(level))) as 0 | 1 | 2 | 3 | 4 | 5;
  return FONT_SIZE_LEVELS[i]?.label ?? 'L';
}

export function getTitleFontSize(fontSizeLevel: number): string {
  switch (fontSizeLevel) {
    case 0: return '7px';
    case 1: return '8px';
    case 2: return '9px';
    case 3: return '11px';
    case 4: return '13px';
    case 5: return '15px';
    default: return '11px';
  }
}

export function getContentFontSize(fontSizeLevel: number): string {
  switch (fontSizeLevel) {
    case 0: return '6px';
    case 1: return '7px';
    case 2: return '8px';
    case 3: return '10px';
    case 4: return '12px';
    case 5: return '14px';
    default: return '10px';
  }
}

export function getTitleMarginBottom(fontSizeLevel: number, isProjectHidden: boolean): string {
  if (isProjectHidden) return '0';
  switch (fontSizeLevel) {
    case 0: return '-3px';
    case 1: return '-2px';
    case 2: return '0';
    case 3: return '4px';
    case 4: return '4px';
    case 5: return '4px';
    default: return '4px';
  }
}
